import useForm from "../../../hooks/useForm";
import { CloseModal } from "../../../hooks/useModal";
import usePageState from "../../../hooks/usePageState";
import { ToppingModel } from "../../../../infrastructure/model/ProductItemModel";
import AppInputDropdown from "../../../components/AppInputDropdown";
import AppInputNumber from "../../../components/AppInputNumber";
import AppInputText from "../../../components/AppInputText/AppInputText";
import BaseDialog from "../../../components/BaseDialog";
import Column from "../../../components/Column";
import DialogFooter from "../../../components/DialogFooter";
import * as Yup from "yup";
import { YES_NO_DATA, YES_NO_ENUM } from "../../../../applications/constants/AppConst";
import {
  createToppingUseCase,
  updateToppingUseCase,
} from "../../../../applications/useCase/ApiUseCase/ItemApiUseCase";
interface InsertToppingDialogProps {
  onClose: CloseModal;
  updateItem?: ToppingModel;
}

function InsertToppingDialog(props: InsertToppingDialogProps) {
  const { onClose, updateItem } = props;
  const { showClientError, showError, setLoading, isLoading } = usePageState();

  async function insertItem(request: ToppingModel) {
    let res: ToppingModel | undefined = undefined;
    if (updateItem?.id) {
      res = await updateToppingUseCase({
        request,
        setLoading,
        showError,
      });
    } else {
      res = await createToppingUseCase({
        request,
        setLoading,
        showError,
      });
    }
    if (res) {
      onClose(res);
    }
  }

  const validationSchema = Yup.object({
    name: Yup.string().required("Thiếu tên sản phẩm"),
    price: Yup.number().required("Thiếu giá sản phẩm"),
  });

  const formik = useForm<ToppingModel>({
    initialValues: updateItem ?? {
      name: "",
      can_sale: true,
      id: 0,
      price: 0,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => await insertItem(values),
  });

  return (
    <BaseDialog
      title={updateItem?.id ? "Cập nhật topping" : "Thêm mới topping"}
      isLoading={isLoading}
      footer={
        <DialogFooter
          submitProps={{
            onClick: () => formik.checkErrorAndSubmit(showClientError),
          }}
          cancelProps={{
            onClick: () => onClose(),
          }}
        />
      }
    >
      <Column className="gap-2 w-100">
        <AppInputText
          label="Tên Topping"
          currentValue={formik.values.name}
          isRequired
          onTextChange={(e) => formik.updateFieldValue("name", e)}
          errorText={formik.getFormErrorMessage("name")}
        />
        <AppInputNumber
          label="Giá sản phẩm"
          currentValue={formik.values.price}
          onChangeValue={(e) => formik.updateFieldValue("price", e)}
          addonAfter="đ"
        />
        <AppInputDropdown
          label="Trạng thái mở bán"
          currentValue={formik.values.can_sale ? YES_NO_ENUM.YES : YES_NO_ENUM.NO}
          onChangeValue={(e) => formik.updateFieldValue("can_sale", e === YES_NO_ENUM.YES)}
          options={YES_NO_DATA}
        />
      </Column>
    </BaseDialog>
  );
}
export default InsertToppingDialog;
